import { render, staticRenderFns } from "./Event.vue?vue&type=template&id=1c408e16&"
import script from "./Event.vue?vue&type=script&lang=ts&"
export * from "./Event.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports